export const FiltersForm = () => {
  const selects = $('.js-select-form');

  selects.each(function () {
    const el = $(this);
    el.select2();
  });
};
